import { render, staticRenderFns } from "./shopOrder.vue?vue&type=template&id=a167d280&scoped=true"
import script from "./shopOrder.vue?vue&type=script&lang=js"
export * from "./shopOrder.vue?vue&type=script&lang=js"
import style0 from "./shopOrder.vue?vue&type=style&index=0&id=a167d280&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a167d280",
  null
  
)

export default component.exports